import { BooleanInput, enforceBoolean } from '../../../typing';

const enforceWithoutAcessors = <T extends object>(target: T, key: PropertyKey): void => {
  Object.defineProperty(target, key, {
    get() {
      return this[`_${key as string}`] as T;
    },
    set(value: BooleanInput) {
      this[`_${key as string}`] = enforceBoolean(value);
    },
    enumerable: true,
    configurable: true,
  });
};

/**
 * Decorator que força o valor de uma propriedade/método de classe para um valor booleano.
 *
 * @category Decorator
 *
 * @example
 * ```ts
 * import { EnforceBoolean } from '@ids/tools';
 *
 * export class ExampleClass {
 *
 *   @EnforceBoolean()
 *   disabled: boolean;
 *  }
 * }
 * ```
 */
export const EnforceBoolean =
  (): PropertyDecorator =>
  (target: object, key: PropertyKey, propertyDescriptor?: PropertyDescriptor) => {
    if (!!propertyDescriptor?.set && !!propertyDescriptor) {
      const originalSetter = propertyDescriptor.set;

      propertyDescriptor.set = function (value: unknown) {
        originalSetter.apply(this, [enforceBoolean(value)]);
      };
    } else {
      enforceWithoutAcessors(target, key);
    }
  };
